export default "__VITE_ASSET__BTOFH72___"